import { LEDGER_CONTRACT_NOTE, } from "@frameworks/web/redux/interfaces/Reports/ILedgerSnapShot";
import { combineReducers } from "redux";
import commonOnePlatFormReducer from "@frameworks/web/redux/reducers/common/commonReducer";
const initLedgerCN = {
    contractNote: [],
};
const LedgerContractNoteReducer = (state = initLedgerCN, action) => {
    switch (action.type) {
        case LEDGER_CONTRACT_NOTE:
            return Object.assign(Object.assign({}, state), { contractNote: action.payload.contractNote });
        default:
            return Object.assign({}, state);
    }
};
export default combineReducers({
    reducersData: LedgerContractNoteReducer,
    commonData: commonOnePlatFormReducer,
});
